import { handleClickColor } from "../../Common/Util";

export function BirthTimeRulingPeriod ({userData,clientData}) {
  return(
  <table class="m-0 p-0 table table-bordered table-hover caption-top text-center">
    <caption class="m-0 p-0" ><h4 class="m-0 p-0 pt-2 pb-1">Birth Time Ruling Period</h4></caption>
    <thead class="m-0 p-0">
      <tr class="m-0 p-0">
        <th class="m-0 p-1"></th> 
        <th class="m-0 p-1">Dasha</th> 
        <th class="m-0 p-1">Bhukti</th> 
        <th class="m-0 p-1">Andharam</th> 
      </tr>
    </thead>
    <tbody class="m-0 p-0">
      <tr class="m-0 p-0" onClick={handleClickColor}>
        <th class="m-0 p-1 bg-transparent text-start">Planet</th>
        <td class="m-0 p-1 bg-transparent">{clientData.dashaName}</td>
        <td class="m-0 p-1 bg-transparent">{clientData.bhuktiName}</td>
        <td class="m-0 p-1 bg-transparent">{clientData.andharamName}</td>
      </tr>  
      <tr class="m-0 p-0" onClick={handleClickColor}>
        <th class="m-0 p-1 bg-transparent text-start">Start Date</th>
        <td class="m-0 p-1 bg-transparent">{userData.birthDate}</td>
        <td class="m-0 p-1 bg-transparent">{userData.birthDate}</td>
        <td class="m-0 p-1 bg-transparent">{userData.birthDate}</td>
      </tr>  
      <tr class="m-0 p-0" onClick={handleClickColor}>
        <th class="m-0 p-1 bg-transparent text-start">End Date</th>
        <td class="m-0 p-1 bg-transparent">{clientData.dashaEnd.substring(0,10)}</td>
        <td class="m-0 p-1 bg-transparent">{clientData.bhuktiEnd.substring(0,10)}</td>
        <td class="m-0 p-1 bg-transparent">{clientData.andharamEnd.substring(0,10)}</td>
      </tr>  
      <tr class="m-0 p-0" onClick={handleClickColor}>
        <th class="m-0 p-1 bg-transparent text-start">Balance</th>
        <td class="m-0 p-1 bg-transparent">{clientData.dashaBalance}</td>
        <td class="m-0 p-1 bg-transparent">{clientData.bhuktiBalance}</td>
        <td class="m-0 p-1 bg-transparent">{clientData.andharamBalance}</td>
      </tr>  
    </tbody>  
  </table>
  );
}